import React from "react";
import NavBar from "./navBar";
import { Carousel } from "react-responsive-carousel";
import TestimonialSlider from "../utils/Testimonies";
import ContactFooter from "../utils/Footer";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import food from "../images/Food.jpg";
import delivery from "../images/delivery.svg";
import appPic from "../images/app.png";
import ImageSliderT from "../utils/ImageSliderT";
import LandingBoy from "../images/LandingBoy.png"
import ShareFood from "../images/sharefood.jpeg";
const Homepage = () => {
  return (
    <div className="">
      <NavBar />
      <ResponsiveComponent />
      <HowWeWork />
      <ServicesComponent />
      <Testimonies />
      <ContactFooter />
    </div>
  );
};

const ResponsiveComponent = () => {
  return (
    <div className="flex flex-wrap items-center">
      {/* <div className="w-full md:w-1/3 p-8 ">
        <h1 className="text-transparent font-bold ml-2 mr-4 lg:text-8xl sm:text-6xl ">
          <span className="text-black ">We help</span> <br />
          <span className="text-orange-500 ">Save Food</span>
        </h1>
        <p className="text-sm mt-12">
          FoodSaver is dedicated to reducing food waste and ensuring that the
          right people get the right help at the right time. We believe that
          every bit of food can make a difference, and our mission is to connect
          surplus food with organizations and individuals who need it the most.
        </p>
      </div>
      <div className="w-full md:w-2/3 p-8">
        <div className="">
          <ImageSlider />
        </div>
      </div> */}

      <div className="relative w-full h-screen bg-white">
        <div className="absolute w-[50%] h-[50%] bg-white top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full blur-[300px] z-10">
        </div>

        <div className="flex w-full justify-center items-center absolute top-0 left-0 z-10">
          <img className=" w-auto h-auto z-50 -mt-64 2xl:-mt-52" src={LandingBoy} alt="" />
        </div>

        <div className="h-full w-full absolute top-0 -left-10 z-10 bg-white bg-opacity-20">
          <div className="flex justify-between">
            <div className="left w-full md:w-6/12 mt-60 pl-52">
              <h1 className="text-orange-500 text-5xl font-extrabold">Help Us to Save Food</h1>

              <p className="mt-5 text-gray-400 w-8/12">FoodSaver reduces food waste by connecting surplus food with those in need. Our mission ensures every bit of food helps people at the right time.</p>
            </div>
            <div className="left w-full md:w-6/12 mt-60 pl-52">
              <h1 className="text-orange-500 text-5xl font-extrabold">Support Us to Provide Hope</h1>

              <p className="mt-5 text-gray-400 w-8/12">FoodSaver provides hope by supporting communities in need. Our mission ensures every effort brings relief, care, and a brighter future to those who need it most.</p>
            </div>
          </div>
        </div>

        {/* <div className="absolute bottom-0 right-0 w-8/12 h-52 max-h-52 z-10 bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-30 flex flex-wrap overflow-hidden divide-x-2 divide-gray-500
">
          <div className="w-4/12 p-3 flex h-full items-center font-semibold text-white hover:bg-white hover:text-gray-950 transform transition ease-in-out duration-300">
            <div className="w-full">
              <h2 className="text-xl font-bold mb-3">Donor</h2>
              <p>Upload any Request or any Availability you have on our portal</p>
            </div>
          </div>
          <div className="w-4/12 p-3 flex h-full items-center font-semibold text-white hover:bg-white hover:text-gray-950 transform transition ease-in-out duration-300">
            <div className="w-full">
              <h2 className="text-xl font-bold mb-3">Receiver</h2>
              <p>Find the right Request and Availability you need and confirm</p>
            </div>
          </div>
          <div className="w-4/12 flex justify-center items-center relative">
            <img className=" h-52 w-auto" src={ShareFood} alt="" />
          </div>
        </div> */}
      </div>
    </div>
  );
};

const ImageSlider = () => {
  const imageList = [
    "https://images.unsplash.com/photo-1567057419565-4349c49d8a04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1172&q=80",
    "https://media.gettyimages.com/id/535555349/photo/group-of-happy-indian-children.jpg?s=612x612&w=0&k=20&c=1zJBdY4-3UfonM955AGb9kHQRcjGQLM6FAuRG_9JGMI=",
    "https://media.gettyimages.com/id/941788480/photo/portrait-of-girl-kid-having-mid-day-meal-in-indian-school.jpg?s=612x612&w=0&k=20&c=tdMRbWtA9rtYSE_6EpXpSl5E4d4xdvqK7egdYd_Q_MM=",
    "https://media.gettyimages.com/id/1295068990/photo/senior-male-friends-having-fun-at-park.jpg?s=612x612&w=0&k=20&c=wKyody-7mgfht5NDonhuDXlN_Z2NnOrwHOlD9JqHdV4=",
  ];

  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      showIndicators={false}
      infiniteLoop
      emulateTouch
      centerMode
      centerSlidePercentage={100}
      selectedItem={0}
      useKeyboardArrows
      autoPlay
      interval={3000}
      transitionTime={800}
      stopOnHover
      className="w-full"
    >
      {imageList.map((image, index) => (
        <div key={index}>
          <img
            src={image}
            alt={`Slide ${index}`}
            className="w-auto h-auto object-cover rounded-xl"
          />
        </div>
      ))}
    </Carousel>
  );
};

const ServiceTile = ({ icon, title }) => {
  return (
    <div className="flex flex-col first-letter:items-center justify-center px-8 py-6 bg-gray-200 bg-opacity-25 hover:bg-opacity-0 transform transition hover:scale-105 duration-500 ease-in-out  shadow-md hover:shadow-lg rounded-lg cursor-pointer h-auto w-auto">
      <div className="text-8xl mb-6 ">{icon}</div>
      <div className="text-lg font-bold mt-4 mb-4 text-orange-400">{title}</div>
      <p className="text-sm mb-12 text-gray-400">
        We provide the best service you ever need.
      </p>
    </div>
  );
};

const ServicesComponent = () => {
  return (
    <div id="services" className="text-center p-4 pt-8 pb-8  bg-white">
      <div className="flex flex-col items-center justify-center mb-8">
      <h4 className="text-3xl font-bold mb-4">
        <span className="text-black">Our</span>{" "}
        <span className="text-orange-500">Services</span>
      </h4>
      <div className="h-1 w-36 bg-gradient-to-r from-white to bg-orange-500 rounded-full opacity-80"></div>
      </div>
      <div className="flex justify-evenly space-x-4 max-w-7xl mx-auto">
        <ServiceTile icon="📝" title="Post Requests" />
        <ServiceTile icon="🤝" title="Connecting" />
        <ServiceTile icon="🚚" title="Pickup" />
      </div>
    </div>
  );
};

const HowWeWork = () => {
  return (
    <div id="about" className="text-center px-8 pt-8 bg-white">
      <div className="flex flex-col items-center justify-center mb-4">
        <h4 className="text-3xl font-bold mb-4">
          <span className="text-black">How</span>{" "}
          <span className="text-orange-500">We Work</span>
        </h4>
        <div className="h-1 w-36 bg-gradient-to-r from-white to bg-orange-500 rounded-full opacity-80"></div>
      </div>

      <div className="flex justify-evenly space-x-4 mt-5 pb-4 max-w-7xl mx-auto">
        <div className="bg-gray-200 group  bg-opacity-25 p-5 rounded-md flex flex-col justify-center items-center w-4/12 hover:bg-opacity-100 transform transition eas-in-out duration-500 cursor-pointer">
          <div className="text-6xl text-orange-500">
                <svg className="w-20 h-20 text-orange-400" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"/></svg>
          </div>
          <div className="text-2xl font-bold mt-9 mb-4 text-orange-400">
            Post your Request
          </div>
          <p className="text-sm  text-gray-400">
          Submit your requests or availability on our portal. Let’s connect resources efficiently and ensure help reaches those in need.
          </p>
        </div>

        <div className="bg-gray-200 group  bg-opacity-25 p-5 rounded-md flex flex-col justify-center items-center w-4/12 hover:bg-opacity-100 transform transition eas-in-out duration-500 cursor-pointer">
        <div className=" flex justify-center">
          <svg className="w-20 h-20 text-orange-400" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
          </div>

          <div className="text-2xl font-bold mt-9 mb-4 text-orange-400">
            Accept an Availability
          </div>
          <p className="text-sm text-gray-400">
          Find the right request or availability you need and confirm it, ensuring timely support and resources for those in need.
          </p>
        </div>

        <div className="bg-gray-200 group  bg-opacity-25 p-5 rounded-md flex flex-col justify-center items-center w-4/12 hover:bg-opacity-100 transform transition eas-in-out duration-500 cursor-pointer">
          <div className="flex justify-center">
          <svg className="w-20 h-20 text-orange-400" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"/></svg>
          </div>
          <div className="text-2xl font-bold mt-9 mb-4 text-orange-400">
            Pick Up your Request
          </div>
          <p className="text-sm text-gray-400 ">
          Confirm your food order and pick it up easily with clear directions, ensuring a smooth and timely collection process.
          </p>
        </div>
      </div>
    </div>
  );
};

const Testimonies = () => {
  return (
    <div id="testi" className="text-center px-8 py-8 pt-8 bg-white">
      <div className="flex flex-col items-center justify-center mb-4">
        <h4 className="text-3xl font-bold mb-4">
          <span className="text-orange-500">Testimonials</span>
        </h4>
        <div className="h-1 w-36 bg-gradient-to-r from-white to bg-orange-500 rounded-full opacity-80"></div>
      </div>
      <div className="flex flex-wrap items-center px-4">
        <div className="w-full max-w-lg mx-auto ">
          <TestimonialSlider />
        </div>
        {/* <div className="w-full md:w-1/2 p-4">
          <ImageSliderT />
        </div> */}
      </div>
    </div>
  );
};



export default Homepage;
